import { render, staticRenderFns } from "./FriendListComponent.vue?vue&type=template&id=7d042c38"
import script from "./FriendListComponent.vue?vue&type=script&lang=js"
export * from "./FriendListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports